import { getValue, setValue } from './select';
import tools from './tools';

// Select2 component
export default function (options = {}, config = {}) {
    let root, instance, isSingle;
    let instantiated = false;

    return {
        get value() {
            return root._x_model ? root._x_model.get() : instance ? instance.val() : getValue(root);
        },

        set value(value) {
            root._x_model ? root._x_model.set(value) : instance ? instance.val(value).trigger('change') : setValue(root, value);
        },

        instance() {
            return instance;
        },

        init() {
            root = this.$root;
            isSingle = root.type === 'select-one';

            if (this.isInModal) {
                this.instantiate();
            }
        },

        destroy() {
            try {
                instance.off('select2:open select2:close select2:select select2:unselect select2:clear');
                instance.select2('destroy');
            } catch (error) {}
        },

        instantiate() {
            if (instantiated) return;
            instantiated = true;

            const classId = 'select2-' + Date.now();
            const computedStyle = window.getComputedStyle(root);
            const height = computedStyle.height;
            let theme;

            if (IS_BOOTSTRAP4) {
                theme = 'bootstrap4';
            } else if (IS_BOOTSTRAP5) {
                theme = 'bootstrap5';
            }

            if (Object.hasOwn(config, 'ajax') && !Object.hasOwn(config.ajax, 'transport')) {
                config.ajax.transport = (params, success, failure) => {
                    const method = (params.type ?? params.method ?? 'GET').toUpperCase();

                    const config = {
                        method: method,
                        url: params.url,
                    };

                    if (method === 'GET') {
                        config.params = params.data;
                    } else {
                        config.data = params.data;
                    }

                    const result = {
                        status: 0,
                    };

                    axios(config)
                        .then((response) => success(response.data, params.data))
                        .catch(() => {
                            result.status = 400;
                            failure();
                        });

                    return result;
                };
            }

            instance = $(root).select2(
                Object.assign(
                    {
                        dropdownParent: this.isInModal ? root.closest('.modal-body') : document.body,
                        dropdownCssClass: classId,
                        language: window.App.locale,
                        theme: theme,
                        placeholder: this.placeholder,
                        allowClear: options.allowClear,
                    },
                    config
                )
            );

            if (!isSingle) {
                root.nextElementSibling.querySelector('.select2-selection--multiple').style.minHeight = height;
            }

            instance.on('select2:open', () => {
                if (isSingle) {
                    this.$nextTick(() => document.querySelector(`.${classId} .select2-search__field`).focus());
                }

                if (this.events) {
                    this.events['x-on:focusin']({
                        type: 'focusin',
                        target: { name: tools.getName(root) },
                    });
                }
            });

            instance.on('select2:close', () => {
                if (this.events) {
                    this.events['x-on:focusout']({
                        type: 'focusout',
                        target: { name: tools.getName(root) },
                    });
                }
            });

            instance.on('select2:select select2:unselect select2:clear', (event) => {
                this.value = getValue(event.target);
                event.target.dispatchEvent(new Event('change', { bubbles: true }));
            });

            this.$nextTick(() => {
                if (root._x_model) {
                    this.$watch(tools.getXModelValue(root), () => instance.trigger('change'));

                    instance.val(root._x_model.get());
                }

                instance.trigger('change');

                if (root.dataset.class) {
                    root.nextElementSibling.classList.add(...root.dataset.class.split(' '));
                }
            });
        },
    };
}
